/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "tabbar"
  }, [_c('tabbar', {
    staticStyle: {
      "background": "#fff",
      "border-top": "none"
    }
  }, _vm._l(_vm.tabbarButton.filter(function (v) {
    return _vm.menuControll(v.routerName);
  }), function (item, index) {
    return _c('tabbar-item', {
      key: index,
      attrs: {
        "icon-class": "tabbar-icon",
        "tabbar-text-active-color": "#3ccba6",
        "selected": item.routerName === _vm.$route.name
      },
      on: {
        "on-item-click": function ($event) {
          return _vm.$router.push({
            name: item.routerName
          });
        }
      }
    }, [item.routerName === 'Home' ? [_c('img', {
      staticClass: "img",
      attrs: {
        "slot": "icon",
        "src": require("../../../assets/tabbarIcon/nohome40_40@3x.png")
      },
      slot: "icon"
    }), _c('img', {
      staticClass: "img",
      attrs: {
        "slot": "icon-active",
        "src": require("../../../assets/tabbarIcon/home40_40@3x.png")
      },
      slot: "icon-active"
    })] : item.routerName === 'Project' ? [_c('img', {
      staticClass: "img2",
      attrs: {
        "slot": "icon",
        "src": require("../../../assets/tabbarIcon/noorder32_40@3x.png")
      },
      slot: "icon"
    }), _c('img', {
      staticClass: "img2",
      attrs: {
        "slot": "icon-active",
        "src": require("../../../assets/tabbarIcon/order32_40@3x.png")
      },
      slot: "icon-active"
    })] : item.routerName === 'Mine' ? [_c('img', {
      staticClass: "img",
      attrs: {
        "slot": "icon",
        "src": require("../../../assets/tabbarIcon/nomine40_40@3x.png")
      },
      slot: "icon"
    }), _c('img', {
      staticClass: "img",
      attrs: {
        "slot": "icon-active",
        "src": require("../../../assets/tabbarIcon/mine40_40@3x.png")
      },
      slot: "icon-active"
    })] : _vm._e(), _c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])], 2);
  }), 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };